export default __webpack_public_path__ + "static/media/img-b-result-distance-at_de@3x.34bee1ff.jpg";